<template>
  <SectionTabHorizLogo01
    v-if="contextData"
    :title="contextData.title"
    :description="contextData.description"
    :tabs="contextTabs"
    :theme="theme"
  />
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    description: string;
    logo?: string;
    tags: string[];
  }

  interface IDfsiData {
    title: string;
    description?: string;
    tabs: {
      tabName: string;
      items: IItem[];
    }[];
  }

  interface IDfsi {
    component: 'dfsi';
    meta: {
      navigable?: string;
    };
    data: IDfsiData;
  }

  type IProps = ISuiteProps<IDfsi>;

  const props = defineProps<IProps>();

  const solutionsStore = useSolutionsStore();
  const { themeStyle } = storeToRefs(solutionsStore);

  const { provideSuiteLogoUrl } = useImagePath(props.urlConnector);

  const contextData = computed((): IDfsiData => props.suiteData.data);

  const contextTabs = computed((): IDfsiData['tabs'] =>
    contextData.value.tabs.map((tabItem) => ({
      ...tabItem,
      items: tabItem.items.map((item) => ({
        ...item,
        logo: provideSuiteLogoUrl(item.logo || ''),
      })),
    }))
  );

  const theme = computed((): TTheme => {
    switch (themeStyle.value) {
      case 'sustainable':
        return 'green';
      case 'connected':
        return 'cyan';
      case 'ai':
        return 'purple';
      case 'operations':
        return 'yellow';
      default:
        return 'blue';
    }
  });

  export type { IDfsi, IDfsiData, IItem };
</script>
